/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_editSchichtPositionMitarbeiterCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', function ($rootScope, $scope, $http, NetworkService, MainService) {

        $rootScope.$on("render_dialog_editSchichtPositionMitarbeitCtrl", function () {
            var dialogData = MainService.getDialogData("dialog_editSchichtPositionMitarbeiter")
            $scope.dialogData = dialogData
            NetworkService.getArbeit(dialogData.schichtObj.schicht_id, dialogData.posObj.position_id, dialogData.email, function (data) {
                $scope.selectedTshirt = data.arbeit.tshirt
                $scope.selectedFood = data.arbeit.essen
                $scope.eingesetzt_als = data.arbeit.text
                setTimeout(function () {
                    $('select').material_select();
                }, 500)


                NetworkService.getFoodForEvent(dialogData.event_id, function (foodData) {
                    var food = foodData.data;
                    $scope.essen = food;
                    if ($scope.essen[0] != undefined)
                    {
                        //$scope.selectedFood = $scope.essen[0]
                        $scope.selectedFood = data.arbeit.essen
                    }
                    setTimeout(function () {
                        $('select').material_select();
                    }, 500)


                })

            })
            NetworkService.getEingesetztAls(function (data)
            {
                $scope.suggests = data.data
            })

        })
        
        $scope.setEingesetztAls = function(eingesetzt_als)
        {
            $scope.eingesetzt_als = eingesetzt_als
        }

        $scope.updateArbeit = function ()
        {
            NetworkService.updateArbeit($scope.dialogData.schichtObj.schicht_id, $scope.dialogData.posObj.position_id, $scope.dialogData.email, $scope.selectedFood, $scope.selectedTshirt, $scope.eingesetzt_als, function () {

            })
        }


    }])